// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Di-z"};